import React from 'react';
import { useSelector } from 'react-redux';
import ListItem from 'components/ListItem';

import { FertilizerApplicationMethod } from 'services/fertilizerEvents/types';
import { AppState } from 'services/types';
import { selectApplicationMethodText } from './selectors';

export interface OwnProps {
    applicationMethod: FertilizerApplicationMethod;
}

type Props = OwnProps;

export default function SummaryApplicationMethodListItem(
    props: Props
): React.ReactElement {
    const applicationMethodText = useSelector((state: AppState) =>
        selectApplicationMethodText(state, props)
    );

    return (
        <ListItem
            description="Application method"
            value={applicationMethodText}
        />
    );
}
